<div class="input-group">
  <!-- Prepend Text -->
  <span *ngIf="props.prependText"
        [ngClass]="props.prependTextClass">{{
    props.prependText
    }}</span>

  <!-- Prepend Button -->
  <!-- CHAT-939: a call site chooses a ROLE, not a class. See the same change
       on phone-input, which shares these prop names. -->
  <button *ngIf="props.prependButtonText"
          kendoButton
          [themeColor]="props.prependButtonThemeColor || 'base'"
          type="button"
          (click)="onPrependButtonClick()">
    {{ props.prependButtonText }}
  </button>

  <!-- Input Field -->
  <input *ngIf="type !== 'number'; else numberTmp"
         [type]="type"
         [formControl]="formControl"
         class="form-control"
         [ngClass]="props.class"
         [formlyAttributes]="field"
         [class.is-invalid]="showError" />
  <ng-template #numberTmp>
    <input type="number"
           [formControl]="formControl"
           class="form-control"
           [ngClass]="props.class"
           [formlyAttributes]="field"
           [class.is-invalid]="showError" />
  </ng-template>

  <!-- Append Text -->
  <span *ngIf="props.appendText"
        [ngClass]="props.appendTextClass">{{
    props.appendText
    }}</span>

  <!-- Append Button -->
  <button *ngIf="props.appendButtonText"
          kendoButton
          [themeColor]="props.appendButtonThemeColor || 'base'"
          type="button"
          (click)="onAppendButtonClick()">
    {{ props.appendButtonText }}
  </button>
</div>